/*
 * @Description:
 * @Author: zhang lin
 * @Date: 2022-10-24 14:25:26
 * @LastEditTime: 2023-07-03 16:57:38
 * @LastEditors: Please set LastEditors
 */
import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';
import { reducerStates } from 'root/store/types';
import { envManage } from '../../store/actions';
import { Button, Spin, Modal } from 'sup-ui';
import CreateBaseForm from '../BaseFormModal';
import ChangeDeployment from '../ChangeDeployment';
import { postHostDataApi, checkNodeStatusApi, checkhHost } from 'root/services/disk';
import messages from '../messages';

import styles from './index.less';
import { message } from 'sup-ui';

const { confirm } = Modal;
const field = ({ fmt, form, setSpining, setInitData, checkNodeUseabled }: any) => {
  const { runtimeEnvId } = useSelector((state: reducerStates) => state.envManage);

  const post = (params: any) => {
    setSpining(true);
    params.labels = [];
    postHostDataApi(params)
      .then((res) => {
        const { data: { id = '' } = {} } = res;
        checkNodeUseabled(id);
      })
      .catch(() => {
        setSpining(false);
      });
  };

  return [
    {
      label: fmt(messages.hostIp),
      key: 'ip',
      type: 'text',
      rules: [
        {
          required: true,
          message: fmt(messages.hostIpRequire),
        },
        () => ({
          validator: (_: any, value: any, callback: any) => {
            if (!value) return callback();
            const flagIp = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))$/;
            if (flagIp.test(value)) {
              return callback();
            } else {
              return callback(fmt(messages.hostIpCheck));
            }
          },
        }),
      ],
      formItemProps: {
        onChange: (e: any) => {
          if (!e.target.value.trim()) {
            form.resetFields();
            console.log(runtimeEnvId); // TODO
            setInitData({ user: 'root' });
          }
        },
        placeholder: fmt(messages.hostIpPlaceholder),
        // disabled: true,
      },
    },
    {
      label: fmt(messages.sshPort),
      key: 'sshPort',
      type: 'text',
      rules: [
        {
          required: true,
          message: fmt(messages.sshPortRequire),
        },
        {
          pattern: new RegExp(/^(([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-5]{2}[0-3][0-5]))$/),
          message: fmt(messages.sshPortCheck),
        },
      ],
      formItemProps: {
        autoComplete: 'new-password',
      },
    },
    {
      label: fmt(messages.userName),
      key: 'user',
      type: 'text',
      rules: [
        {
          required: true,
          message: fmt(messages.countRequire),
        },
      ],
      formItemProps: {
        disabled: true,
      },
    },
    {
      label: fmt(messages.pwd),
      key: 'pwd',
      type: 'password',
      rules: [
        {
          required: true,
          message: fmt(messages.pwdRequire),
        },
      ],
      formItemProps: {
        autoComplete: 'new-password',
        visibilityToggle: false,
      },
    },
    {
      label: ' ',
      key: 'btn',
      type: 'submit',
      colon: false,
      renderFormItem: () => {
        return (
          <Button
            type="primary"
            htmlType="submit"
            onClick={() => {
              form.validateFields((err: any, values: any) => {
                if (err) return;
                setInitData(values);
                const { pwd, ip, sshPort, user } = values;
                const params = {
                  ip,
                  sshPort,
                  user,
                  password: pwd,
                  name: 'test', // 联调时需要，正式时需要删除
                };
                setSpining(true);
                checkhHost(params)
                  .then((res) => {
                    if (res.data === 1) {
                      setSpining(false);
                      confirm({
                        title: '当前主机已被其他运维平台添加，是否确认添加?',
                        onOk: () => {
                          post(params);
                        },
                      });
                      return;
                    }
                    post(params);
                  })
                  .catch(() => {
                    setSpining(false);
                  });
              });
            }}
          >
            {fmt(messages.submit)}
          </Button>
        );
      },
    },
  ];
};

const AddAloneHost = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [spining, setSpining] = useState(false);
  const { opsPort = '22', opsIp } = useSelector((state: reducerStates) => state.envManage);
  const [initData, setInitData] = useState({ user: 'root', sshPort: opsPort, ip: opsIp });
  let loopTimer: any = null;

  useEffect(() => {
    return () => {
      clearTimeout(loopTimer);
    };
  }, []);

  // 论询
  const loopGetData = (id: string) => {
    loopTimer = setTimeout(() => {
      clearTimeout(loopTimer);
      checkNodeUseabled(id);
    }, 1000 * 3);
  };

  const AddFrom = CreateBaseForm({
    formProps: { name: 'addAloneHost' },
    messages,
  })(field);

  const checkNodeUseabled = (id: string) => {
    // 检查到有节点才跳转
    checkNodeStatusApi({ serverNodeId: id }).then((res: any) => {
      const { data } = res;
      if (data) {
        setSpining(false);
        message.success(intl.formatMessage(messages.addSuccess));
        dispatch(
          envManage.changeEnvStatus({
            singleNodeId: id, // 节点id
          }),
        );
      } else {
        loopGetData(id);
      }
    });
  };

  return (
    <div className={styles.add_host_form}>
      <Spin spinning={spining}>
        <h1>{intl.formatMessage(messages.addHostTitle)}</h1>
        <AddFrom
          checkNodeUseabled={checkNodeUseabled}
          setSpining={setSpining}
          labelCol={{ span: 5 }}
          setInitData={setInitData}
          wrapperCol={{ span: 19 }}
          initData={initData}
        />
        <ChangeDeployment />
      </Spin>
    </div>
  );
};

export default AddAloneHost;
